import { useEffect } from "react";
import { useIsNewEntry } from "src/hooks/useIsNewEntry";
import { useSelector } from "src/redux/hooks";

import { useGeneratorStore } from "../store";
import type { V2LogbookDef } from "../types";

export function useV2NewEntry() {
  const isNewEntry = useIsNewEntry();
  const lbentry = useSelector(state => state.generatorSlice.lbentry);
  const hydrate = useGeneratorStore(s => s.hydrate);

  useEffect(() => {
    if (isNewEntry && lbentry?.generator === "v2") {
      hydrate(lbentry as unknown as V2LogbookDef);
    }
  }, [isNewEntry, lbentry, hydrate]);
}
